import { useQueries } from "@tanstack/react-query";
import fileService from "api/fileService";
import useToken from "components/hooks/useToken";

const fetchTicketVentaUrl = async (
  urlTicketVenta: string,
  token: string
): Promise<string> => {
  const fileNameMatch = urlTicketVenta.match(/solicitudes\/\d+\/.*$/);
  if (!fileNameMatch) {
    throw new Error("URL no válida");
  }
  const fileName = fileNameMatch[0];

  const fileServicePath = fileService(token, "consumo");

  const response = await fileServicePath.download(
    encodeURIComponent(fileName.toLowerCase()).replace(/%2520/g, "%20")
  );

  if (response) {
    return response.url;
  } else {
    throw new Error("No se pudo descargar el archivo");
  }
};

export const useTicketsVentaUrls = (urls: string[], enabled: boolean) => {
  const token = useToken();

  const queries = useQueries({
    queries: urls.map((url) => ({
      queryKey: ["ticketVentaUrl", url],
      queryFn: () => fetchTicketVentaUrl(url, token),
      enabled,
      retry: false,
    })),
  });

  return {
    data: queries.map((q) => q.data),
    isLoading: queries.map((q) => q.isLoading),
  };
};
